// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"UieIv","smallLinkTypography":"_2qEh9","titleTypography":"_6LmPt","cardTitleTypography":"_3lWvx","nameCell":"_2S-gp","truncate":"_1THHt","base":"_3lKO5","noRecord":"n1hlw","buttonAction":"_2Usqv","buttonLeft":"qxCn-","buttonRight":"_2iTzh","buttonBorder":"_6U13H","buttonContainer":"hCDb1","flexDirection":"_4FnKQ","buttonElement1":"_1NZ1j","buttonElement2":"_1k8JD","buttonElement3":"jJcbR","buttonElement4":"GtA8G","filter":"_2k0iF"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerPlans/components/Admin/PartnerPlanAdminList.scss
// module id = 785
// module chunks = 0